import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { COLORS } from '../../styles/tokens';

// Bunnark som legger seg over siden: mørk bakgrunn, hvit flate med dra-håndtak.
// Brukes til bekreftelser og handlinger på mobil. busy hindrer lukking mens noe pågår.
export default function SheetModal({ onClose, busy = false, children, label }) {
  useEffect(() => {
    const onKey = e => { if (e.key === 'Escape' && !busy) onClose(); };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [busy, onClose]);

  return ReactDOM.createPortal(
    <div className="orderer-ui" style={styles.overlay} onClick={busy ? undefined : onClose}>
      <div role="dialog" aria-modal="true" aria-label={label} style={styles.sheet} onClick={e => e.stopPropagation()}>
        <div style={styles.grab} />
        {children}
      </div>
    </div>,
    document.body
  );
}

const styles = {
  overlay: { position: 'fixed', inset: 0, background: 'rgba(20,20,30,0.5)', zIndex: 1500, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  sheet:   { background: COLORS.white, width: '100%', maxWidth: 520, maxHeight: '92vh', overflowY: 'auto', borderRadius: '26px 26px 0 0', padding: '8px 20px max(24px, env(safe-area-inset-bottom))' },
  grab:    { width: 40, height: 4, borderRadius: 2, background: COLORS.border, margin: '0 auto 16px' },
};

// Knapper i bunnarkene
export const sheetButtons = {
  title:   { fontFamily: "'Barlow Condensed', sans-serif", fontWeight: 700, fontSize: 30, lineHeight: 1.05, margin: '0 0 8px', color: COLORS.textDark },
  text:    { fontSize: 14.5, color: COLORS.textMid, lineHeight: 1.45, margin: '0 0 18px' },
  gold:    { width: '100%', height: 52, borderRadius: 26, border: 'none', background: COLORS.accent, color: '#1a1a2e', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  red:     { width: '100%', height: 52, borderRadius: 26, border: 'none', background: COLORS.danger, color: '#fff', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  green:   { width: '100%', height: 52, borderRadius: 26, border: 'none', background: COLORS.success, color: '#fff', fontSize: 16, fontWeight: 700, cursor: 'pointer' },
  ghost:   { width: '100%', height: 52, borderRadius: 26, border: `1.5px solid ${COLORS.primary}`, background: COLORS.white, color: COLORS.textDark, fontSize: 16, fontWeight: 700, cursor: 'pointer', marginTop: 10 },
  error:   { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '10px 12px', borderRadius: 10, fontSize: 14, margin: '0 0 12px' },
};
